import React from 'react';
import i18n from 'i18next';
import Close from '@mui/icons-material/Close';
import Folder from '@mui/icons-material/Folder';
import Label from '@mui/icons-material/Label';

import { Button } from 'uikit/buttons';
import { Icon } from 'uikit/icons';
import { Typo } from 'uikit/content';
import { ListBody, ListHeader } from '@/exceed';

import getLocales from '../helpers/getLocales';

import styles from '../styles/initiativeUsage.module.scss';

const InitiativeUsage = ({
  addMenuItems,
  hasHelp,
  filterSelection,
  isLoading,
  onClearButtonClick,
  onCloseButtonClick,
  onFilterChange,
  onUsageSelectionChange,
  onRemoveButtonClick,
  onToggleAll,
  usage,
  usageSelection,
}) => {
  const usageCount = usage.length;
  const usageSelectionCount = usageSelection.length;

  return (
    <>
      {hasHelp && (
        <div className={styles.helpContainer}>
          <Icon className={styles.icon} icon="insights" size={28} />
          <Typo color="secondary" className={styles.help} variant="b01">
            {i18n.t('usage-body')}
          </Typo>
          <Button
            ariaLabel={i18n.t('dismiss')}
            icon={<Close />}
            onClick={onCloseButtonClick}
            size="xsmall"
            variant="ghost"
          />
        </div>
      )}
      <ListHeader
        addMenuItems={addMenuItems}
        buttons={[
          {
            icon: 'restricted',
            iconSize: 10,
            onClick: onRemoveButtonClick,
            size: 'small',
            text: i18n.t('remove'),
            variant: 'outlined',
          },
        ]}
        checkboxValue={Boolean(usageCount) && usageCount === usageSelectionCount}
        filters={[
          { key: 'locale', label: i18n.t('locale'), options: getLocales() },
          // {
          //   key: 'sort',
          //   label: i18n.t('sort'),
          //   options: [
          //     { label: i18n.t('alphabetical'), value: 'alphabetical' },
          //     { label: i18n.t('last-updated'), value: 'updated' },
          //   ],
          // },
        ]}
        hasAddMenu
        hasButtons={Boolean(usageSelectionCount)}
        hasCheckbox
        hasFilters
        isCheckboxDisabled={isLoading || !usageCount}
        nameText={i18n.t('content-name')}
        onCheckboxChange={onToggleAll}
        onClearButtonClick={onClearButtonClick}
        onFilterChange={onFilterChange}
        filterSelection={filterSelection}
        shouldDisableFilters={!usageCount && !filterSelection.locale}
        title={i18n.t('usage')}
      />
      <ListBody
        data={usage.map((item) => ({
          ...item,
          icon: item.type !== 'Category' ? <Label /> : <Folder />,
        }))}
        emptyComponent={<Typo className={styles.empty}>{i18n.t('usage-empty')}</Typo>}
        hasCheckbox
        isLoading={isLoading}
        onCheckboxChange={onUsageSelectionChange}
        selection={usageSelection}
      />
    </>
  );
};

export default React.memo(InitiativeUsage);
